import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import Form from './uploadexcelshipperadvice';
import UploadStatus from './excelupload/uploadstatus';
import './excelupload/bulkbooking.css';

const UploadShipperAdvice = () => {
    const state = useSelector(state => { return { appData: state.appData, ShipperAdvice: state.shipperAdviceData } });
    const { userInfo } = state.appData;
    const { uploadedGridStatus } = state.ShipperAdvice;

    const history = useHistory();

    const myWorker = React.useRef(new Worker('./advicebulkwebworker.js'));
    let worker = myWorker.current;
    useEffect(() => {
        if (!worker) {
            worker = new Worker('./advicebulkwebworker.js')
        }
        return () => {
            worker.terminate();
            worker = null;
        }
    }, [])

    useEffect(() => {
        if (!valdiatePage('/shipperadvice')) {
            history.push('/login');
        }
    }, []);

    return userInfo && <section className="section">
        <div className="card sticky" style={{ padding: 10 }}>
            <Form myWorker={worker} />
            {uploadedGridStatus && uploadedGridStatus.length > 0 && (
                <UploadStatus data={uploadedGridStatus} />
            )}
        </div>
    </section>
}

export default UploadShipperAdvice;